export const atType = '@type';
export const atContext = '@context';
export const queryInput = 'query-input';
